/**
 * RelatedPosts — Shows related blog posts at the bottom of an article.
 */

import type { BlogPost } from '../../types/blog';
import { BlogCard } from './BlogCard';
import { useLangStore } from '../../store/langStore';

interface RelatedPostsProps {
  posts: BlogPost[];
}

export function RelatedPosts({ posts }: RelatedPostsProps) {
  const { lang } = useLangStore();

  if (posts.length === 0) return null;

  return (
    <section className="max-w-5xl mx-auto mt-16 mb-12">
      <h2 className="font-display font-bold text-ink text-2xl mb-8 text-center">
        {lang === 'no' ? 'Les også' : 'Also read'}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.map(post => (
          <BlogCard key={post.slug} post={post} />
        ))}
      </div>
    </section>
  );
}
